import { useEffect, useState } from "react";
import { segmentationAPI } from "../axios/segmentation";

export default function usePageSegmentation(filename, enabled) {
  const [result, setResult] = useState(null);
  useEffect(() => {
    if (!enabled || !filename) return undefined;
    let cancelled = false;
    const controller = new AbortController();
    setResult({ filename, status: "loading" });
    segmentationAPI.get(filename, { signal: controller.signal }).then((response) => {
      if (!cancelled) setResult({ filename, status: "ready", data: response.data });
    }).catch((error) => {
      if (!cancelled) setResult({ filename, status: error.response?.status === 404 ? "absent" : "failed" });
    });
    return () => { cancelled = true; controller.abort(); };
  }, [filename, enabled]);
  // Hide the old page immediately, before the next effect or request completes.
  return enabled && result?.filename === filename ? result : { status: enabled ? "loading" : "idle" };
}
